const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

// want to adopt this and open source this...
// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('[data-tile]').forEach(element => setupDataTile(element))
// })

// function setupDataTile(element) {
//   let trigger = element.querySelector('[data-behavior="uppy-trigger"]')
//   let form = element.closest('form')
//   let direct_upload_url = document.querySelector("meta[name='direct-upload-url']").getAttribute("content")
//   let field_name = element.dataset.uppy
//   trigger.addEventListener("click", (event) => event.preventDefault())
// }


function setText(element, text) { 

  let textValue = element.dataset['type'] == 'money' ? formatter.format(text/100) : text

   if (document.body.innerText) {
     element.innerText = textValue;
   } else {
     element.textContent = textValue;
   }
 }

function ajaxCall(node, url, params, success, error){
  let $ = window.jQuery || window.Zepto || window.$;

  if ($ && $.ajax) {
    $.ajax({
      dataType: "json",
      url: url,
      success: success,
      error: error
    }).done(function(data){
      setText(node, data)
    });
  } else {
    let xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");

    xhr.onload = function () {
      if (xhr.status === 200) {
        setText(node, JSON.parse(xhr.responseText))
      } else {
        error(xhr, "error", xhr.statusText);
      }
    };
    xhr.send();
  }
}

function getDataTileJSON(node, url, success, error) {
  ajaxCall(node, url, success, function (jqXHR, textStatus, errorThrown) {
    var message = (typeof errorThrown === "string") ? errorThrown : errorThrown.message;
    error(message);
  });
}

$(document).ready(function() {
  let numberCharts = document.querySelectorAll('.data-loading');
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get('year') || new Date().getFullYear();
  

  if (numberCharts.length > 0){
    numberCharts.forEach(function(el) {
      getDataTileJSON(el, el.dataset['url'])
    });
  }
});